import LoadDocs from './LoadDocs';

export {LoadDocs};



/** WEBPACK FOOTER **
 ** ./src/modules/documents/actions/index.js
 **/